import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { 
  fetchOTAChannels, 
  createOTAChannel, 
  updateOTAChannel, 
  deleteOTAChannel,
  OTAChannelsResponse 
} from '@/api/ota-channels';
import { OTAChannel } from '@/types/revenue-manager';

export function useOTAChannels(branchId?: string | number) {
  return useQuery<OTAChannelsResponse>({
    queryKey: ['ota-channels', branchId],
    queryFn: () => fetchOTAChannels(branchId),
    enabled: !!branchId, // Only fetch when branchId is available
  });
}

export function useCreateOTAChannel() {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: (channel: Omit<OTAChannel, 'id'>) => createOTAChannel(channel),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['ota-channels'] });
    },
  });
}

export function useUpdateOTAChannel() {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: ({ channelId, updates }: { channelId: string; updates: Partial<OTAChannel> }) => 
      updateOTAChannel(channelId, updates),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['ota-channels'] });
    },
  });
}

export function useDeleteOTAChannel() {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: (channelId: string) => deleteOTAChannel(channelId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['ota-channels'] });
    },
  });
}
